// extracted by mini-css-extract-plugin
module.exports = {"custom-drag-layer":"_3sHBx","custom-drag-element":"_1lXLe"};